/* CPH Luggage Premium: header, megamenu, søgning, kontopanel, mobilmenu og kurvskuffe. Plutonic, 2026-09-30.
   Ingen afhængigheder. Kurvskuffen ligger i assets/cphl-cart.js. */
(function () {
  'use strict';

  var root, hd, scrim;
  var st = { mega: null, acc: false, menu: false, search: false, sub: null };
  var lastFocus = null;
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)');
  var desk = window.matchMedia('(min-width: 1100px)');

  function q(s, c) { return (c || document).querySelector(s); }
  function qa(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function anyOpen() { return !!(st.mega || st.acc || st.menu || st.search); }
  function lock(on) { document.documentElement.classList.toggle('cphl-lock', !!on); }
  function focusables(el) {
    return qa('a[href], button:not([disabled]), input:not([type=hidden]), select, textarea, [tabindex]:not([tabindex="-1"])', el)
      .filter(function (x) { return x.offsetParent !== null || x === document.activeElement; });
  }
  function trap(el, e) {
    var f = focusables(el);
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }
  function debounce(fn, ms) { var t; return function () { var a = arguments, s = this; clearTimeout(t); t = setTimeout(function () { fn.apply(s, a); }, ms); }; }
  function setExpanded(sel, val) { qa(sel, root).forEach(function (b) { b.setAttribute('aria-expanded', val ? 'true' : 'false'); }); }
  function syncState() {
    root.classList.toggle('has-mega', !!st.mega);
    root.classList.toggle('has-acc', st.acc);
    root.classList.toggle('has-menu', st.menu);
    root.classList.toggle('has-search', st.search);
    var sec = root.closest('.shopify-section');
    if (sec) sec.classList.toggle('is-front', anyOpen());
    if (anyOpen()) { hd.classList.add('is-solid'); hd.classList.remove('is-hidden'); }
    else if (root.dataset.overlay === 'true' && window.scrollY < 10 && !hd.matches(':hover')) hd.classList.remove('is-solid');
  }

  /* USP-bar: roterer hvert 4,5 sekund, pile på computer, swipe på mobil */
  function initUsps() {
    var wrap = q('[data-usps]', root);
    if (!wrap) return;
    var items = qa('.cphl-ann__item', wrap);
    if (items.length < 2) return;
    var i = 0, timer = null;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function go(n) {
      var cur = items[i];
      cur.classList.remove('is-on');
      cur.classList.add('is-out');
      setTimeout(function () { cur.classList.remove('is-out'); }, 650);
      i = (n + items.length) % items.length;
      items[i].classList.add('is-on');
    }
    function loop() { clearInterval(timer); if (!reduce) timer = setInterval(function () { if (!document.hidden) go(i + 1); }, 4500); }
    qa('[data-usp-step]', wrap).forEach(function (b) {
      b.addEventListener('click', function () { go(i + parseInt(b.getAttribute('data-usp-step'), 10)); loop(); });
    });
    var x0 = null;
    wrap.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    wrap.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      x0 = null;
      if (Math.abs(dx) > 30) { go(i + (dx < 0 ? 1 : -1)); loop(); }
    }, { passive: true });
    loop();
  }

  /* Butikkens status ud fra åbningstiderne (dansk tid) */
  function initStore() {
    var hours;
    try { hours = JSON.parse(root.getAttribute('data-hours') || '[]'); } catch (e) { return; }
    if (!hours || hours.length !== 7) return;
    var now;
    try { now = new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Copenhagen' })); } catch (e) { now = new Date(); }
    var days = ((window.cphlT && cphlT.chrome_days) || 'søndag,mandag,tirsdag,onsdag,torsdag,fredag,lørdag').split(',');
    function parse(s) {
      var m = /^\s*(\d{1,2})(?:[.:](\d{2}))?\s*-\s*(\d{1,2})(?:[.:](\d{2}))?\s*$/.exec(s || '');
      return m ? [m[1] * 60 + (+m[2] || 0), m[3] * 60 + (+m[4] || 0)] : null;
    }
    function fmt(mins) {
      var h = Math.floor(mins / 60), mm = mins % 60;
      var tpl = mm ? ((window.cphlT && cphlT.chrome_time_hm) || '{h}.{mm}') : ((window.cphlT && cphlT.chrome_time_h) || '{h}');
      return tpl.replace('{h}', h).replace('{mm}', (mm < 10 ? '0' : '') + mm);
    }
    var d = now.getDay(), mins = now.getHours() * 60 + now.getMinutes();
    var today = parse(hours[d]);
    var open = !!(today && mins >= today[0] && mins < today[1]);
    var short;
    if (open) short = ((window.cphlT && cphlT.chrome_open_until) || 'Åben nu til kl. {t}').replace('{t}', fmt(today[1]));
    else if (today && mins < today[0]) short = ((window.cphlT && cphlT.chrome_opens_today) || 'Åbner i dag kl. {t}').replace('{t}', fmt(today[0]));
    else {
      short = '';
      for (var k = 1; k <= 7; k++) {
        var nd = (d + k) % 7, nh = parse(hours[nd]);
        if (nh) {
          short = (k === 1 ? ((window.cphlT && cphlT.chrome_opens_tomorrow) || 'Lukket nu, åbner i morgen kl. {t}') : ((window.cphlT && cphlT.chrome_opens_day) || 'Lukket nu, åbner {day} kl. {t}'))
            .replace('{day}', days[nd]).replace('{t}', fmt(nh[0]));
          break;
        }
      }
    }
    if (!short) return;
    /* Adressen læses én gang fra Liquid-teksten og gemmes, så opdateringen hvert minut ikke læser sin egen tekst igen (kl. 10:00 gav "· 00 · 00"). Gaden ligger i sit eget span, så den kan skjules på smalle skærme. Plutonic, 2026-10-08. */
    var stEl = q('[data-store-status]', root);
    if (stEl && !stEl.hasAttribute('data-addr')) stEl.setAttribute('data-addr', stEl.textContent || '');
    var addr = stEl ? stEl.getAttribute('data-addr') : '';
    var street = addr.indexOf(':') > -1 ? addr.split(':')[1].split(',')[0].trim() : '';
    qa('[data-store-status]').forEach(function (el) {
      el.textContent = short;
      if (street) { var sp = document.createElement('span'); sp.className = 'cphl-ann__addr'; sp.textContent = ' · ' + street; el.appendChild(sp); }
    });
    qa('[data-store-status-short]').forEach(function (el) { el.textContent = short; });
    qa('[data-store-dot]').forEach(function (el) { el.classList.toggle('is-open', open); });
    qa('[data-store-live]').forEach(function (el) { el.textContent = open ? ((window.cphlT && cphlT.chrome_live_open) || ', åben nu') : ''; });
  }

  /* Leveringsdato ud fra butikkens egen leveringstid i hverdage (dansk tid, uden weekender og helligdage).
     Elementer med data-eta="1-2" og data-eta-tpl="Levering typisk {d}" får teksten, fx "Levering typisk tors. 1. til fre. 2. okt." */
  var HOLI = ' 2026-12-24 2026-12-25 2026-12-26 2026-12-31 2027-01-01 2027-03-25 2027-03-26 2027-03-29 2027-05-06 2027-05-17 2027-06-05 2027-12-24 2027-12-25 2027-12-26 2027-12-31 2028-01-01 2028-04-13 2028-04-14 2028-04-17 2028-05-25 2028-06-05 2028-12-24 2028-12-25 2028-12-26 2028-12-31 ';
  function ymd(d) { return d.toISOString().slice(0, 10); }
  function isBiz(d) { var w = d.getUTCDay(); return w !== 0 && w !== 6 && HOLI.indexOf(' ' + ymd(d) + ' ') < 0; }
  function eta(min, max) {
    var t = '';
    try {
      var parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Copenhagen', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date());
      var o = {}; parts.forEach(function (x) { o[x.type] = x.value; });
      t = o.year + '-' + o.month + '-' + o.day;
    } catch (e) { t = ymd(new Date()); }
    var d = new Date(t + 'T12:00:00Z');
    if (isNaN(d.getTime())) return '';
    while (!isBiz(d)) d.setUTCDate(d.getUTCDate() + 1);
    function add(n) { var x = new Date(d.getTime()); while (n > 0) { x.setUTCDate(x.getUTCDate() + 1); if (isBiz(x)) n--; } return x; }
    var a = add(min), b = add(max);
    var W = ((window.cphlT && cphlT.chrome_wd_short) || 'søn.,man.,tirs.,ons.,tors.,fre.,lør.').split(',');
    var M = ((window.cphlT && cphlT.chrome_mon_short) || 'jan.,feb.,mar.,apr.,maj,jun.,jul.,aug.,sep.,okt.,nov.,dec.').split(',');
    var F = (window.cphlT && cphlT.chrome_date_full) || '{w} {d}. {m}';
    var S = (window.cphlT && cphlT.chrome_date_short) || '{w} {d}.';
    var R = (window.cphlT && cphlT.chrome_date_range) || '{a} til {b}';
    function fill(tpl, x) { return tpl.replace('{w}', W[x.getUTCDay()]).replace('{d}', x.getUTCDate()).replace('{m}', M[x.getUTCMonth()]); }
    function full(x) { return fill(F, x); }
    if (ymd(a) === ymd(b)) return full(a);
    if (a.getUTCMonth() === b.getUTCMonth()) return R.replace('{a}', fill(S, a)).replace('{b}', full(b));
    return R.replace('{a}', full(a)).replace('{b}', full(b));
  }
  window.cphlEta = eta;
  function applyEta(scope) {
    qa('[data-eta]', scope).forEach(function (el) {
      var r = String(el.getAttribute('data-eta') || '').split('-');
      var min = parseInt(r[0], 10), max = parseInt(r[1] || r[0], 10);
      if (isNaN(min) || isNaN(max) || min < 0 || max < min) return;
      var txt = eta(min, max);
      if (!txt) return;
      el.textContent = (el.getAttribute('data-eta-tpl') || (window.cphlT && cphlT.chrome_eta_tpl) || 'Levering typisk {d}').replace('{d}', txt);
      el.hidden = false;
    });
  }

  /* Klæbende header: solid efter 10 px, gemmer sig ved scroll ned og kommer frem ved scroll op */
  function initSticky() {
    var overlay = root.dataset.overlay === 'true';
    var hide = root.dataset.hide === 'true';
    var last = window.scrollY, ticking = false;
    function update() {
      ticking = false;
      var y = window.scrollY;
      root.classList.toggle('is-scrolled', y > 1);
      if (overlay) hd.classList.toggle('is-solid', y > 10 || anyOpen() || hd.matches(':hover'));
      else hd.classList.add('is-solid');
      if (hide) {
        var drawer = document.documentElement.classList.contains('cphl-cart-open');
        if (y < 200 || anyOpen() || drawer) hd.classList.remove('is-hidden');
        else if (y > last + 6) { hd.classList.add('is-hidden'); if (st.mega) closeMega(); if (st.acc) closeAcc(); }
        else if (y < last - 6) hd.classList.remove('is-hidden');
        document.documentElement.classList.toggle('cphl-hd-hidden', hd.classList.contains('is-hidden'));
      }
      if (Math.abs(y - last) > 6 || y < 10) last = y;
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; window.requestAnimationFrame(update); } }, { passive: true });
    if (overlay) {
      hd.addEventListener('mouseenter', function () { if (fine.matches) hd.classList.add('is-solid'); });
      hd.addEventListener('mouseleave', function () { setTimeout(update, 30); });
    }
    update();
  }


  /* Menuen skal kunne være der: ellers strammes afstandene, og ellers bruges burgermenuen også på computer */
  function initFit() {
    var nav = q('.cphl-hd__nav', hd), left = q('.cphl-hd__left', hd);
    if (!nav || !left) return;
    function over() { return nav.scrollWidth + parseFloat(getComputedStyle(nav).marginLeft || 0) > left.clientWidth + 1; }
    function fit() {
      hd.classList.remove('is-tight', 'is-burger');
      if (!desk.matches) return;
      if (over()) {
        hd.classList.add('is-tight');
        if (over()) { hd.classList.remove('is-tight'); hd.classList.add('is-burger'); }
      }
    }
    fit();
    window.addEventListener('resize', debounce(fit, 120));
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
  }

  /* Megamenuer: hover med lille forsinkelse på computer, klik og tastatur overalt */
  var megaOpenT, megaCloseT;
  function openMega(id) {
    if (hd.classList.contains('is-burger')) return;
    if (st.acc) closeAcc(true);
    st.mega = id;
    qa('[data-mega]', hd).forEach(function (p) { p.classList.toggle('is-open', p.getAttribute('data-mega') === String(id)); });
    qa('[data-mega-open]', hd).forEach(function (a) { a.setAttribute('aria-expanded', a.getAttribute('data-mega-open') === String(id) ? 'true' : 'false'); });
    syncState();
  }
  function closeMega() {
    st.mega = null;
    qa('[data-mega]', hd).forEach(function (p) { p.classList.remove('is-open'); });
    setExpanded('[data-mega-open]', false);
    syncState();
  }
  function initMega() {
    qa('[data-mega-open]', hd).forEach(function (a) {
      var id = a.getAttribute('data-mega-open');
      var panel = document.getElementById('CphlMega-' + id);
      if (!panel) return;
      var li = a.parentNode;
      li.addEventListener('mouseenter', function () {
        if (!fine.matches) return;
        clearTimeout(megaCloseT); clearTimeout(megaOpenT);
        megaOpenT = setTimeout(function () { openMega(id); }, st.mega ? 0 : 110);
      });
      li.addEventListener('mouseleave', function () {
        if (!fine.matches) return;
        clearTimeout(megaOpenT);
        megaCloseT = setTimeout(closeMega, 180);
      });
      panel.addEventListener('mouseenter', function () { clearTimeout(megaCloseT); });
      panel.addEventListener('mouseleave', function () { if (fine.matches) megaCloseT = setTimeout(closeMega, 180); });
      a.addEventListener('click', function (e) {
        if (st.mega === id && fine.matches) return;
        e.preventDefault();
        if (st.mega === id) closeMega(); else openMega(id);
      });
      a.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown' || e.key === ' ') {
          e.preventDefault();
          openMega(id);
          var f = q('a', panel);
          if (f) f.focus();
        }
      });
    });
    qa('.cphl-hd__li > a:not([data-mega-open])', hd).forEach(function (a) {
      a.addEventListener('mouseenter', function () { if (fine.matches && st.mega) { clearTimeout(megaOpenT); megaCloseT = setTimeout(closeMega, 120); } });
    });
    hd.addEventListener('focusout', function (e) {
      if (st.mega && e.relatedTarget && !hd.contains(e.relatedTarget)) closeMega();
    });
  }

  /* Kontopanel */
  function openAcc() {
    var p = q('[data-acc]', root);
    if (!p) return;
    if (st.mega) closeMega();
    st.acc = true;
    lastFocus = document.activeElement;
    p.classList.add('is-open');
    setExpanded('[data-open-account]', true);
    syncState();
    var f = q('.cphl-acc__cta, .cphl-acc__links a', p);
    if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 60);
  }
  function closeAcc(silent) {
    var p = q('[data-acc]', root);
    st.acc = false;
    if (p) p.classList.remove('is-open');
    setExpanded('[data-open-account]', false);
    syncState();
    if (!silent && lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  function initAccount() {
    var p = q('[data-acc]', root);
    if (!p) return;
    qa('[data-open-account]', root).forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); if (st.acc) closeAcc(); else openAcc(); });
    });
    var x = q('[data-close]', p);
    if (x) x.addEventListener('click', function () { closeAcc(); });
    document.addEventListener('click', function (e) {
      if (st.acc && !p.contains(e.target) && !e.target.closest('[data-open-account]')) closeAcc(true);
    });
  }

  /* Mobilmenu med undermenuer */
  function openMenu() {
    var m = q('[data-mm]', root);
    if (!m) return;
    closeSearch(true);
    st.menu = true;
    lastFocus = document.activeElement;
    m.classList.add('is-open');
    setExpanded('[data-open-menu]', true);
    lock(true);
    syncState();
    setTimeout(function () { var x = q('.cphl-mm__x', m); if (x) x.focus({ preventScroll: true }); }, 80);
  }
  function closeMenu(silent) {
    var m = q('[data-mm]', root);
    if (!m) return;
    st.menu = false;
    m.classList.remove('is-open');
    closeSub();
    setExpanded('[data-open-menu]', false);
    if (!st.search) lock(false);
    syncState();
    if (!silent && lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  function openSub(id) {
    var s = q('[data-sub="' + id + '"]', root);
    if (!s) return;
    st.sub = id;
    s.classList.add('is-open');
    qa('[data-sub-open="' + id + '"]', root).forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    setTimeout(function () { var b = q('[data-sub-back]', s); if (b) b.focus({ preventScroll: true }); }, 60);
  }
  function closeSub() {
    if (!st.sub) return;
    var id = st.sub;
    st.sub = null;
    qa('[data-sub]', root).forEach(function (s) { s.classList.remove('is-open'); });
    qa('[data-sub-open]', root).forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    var t = q('[data-sub-open="' + id + '"]', root);
    if (t) t.focus({ preventScroll: true });
  }
  function initMenu() {
    var m = q('[data-mm]', root);
    if (!m) return;
    qa('[data-open-menu]', root).forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); openMenu(); }); });
    var x = q('.cphl-mm__x', m);
    if (x) x.addEventListener('click', function () { closeMenu(); });
    qa('[data-sub-open]', m).forEach(function (b) { b.addEventListener('click', function () { openSub(b.getAttribute('data-sub-open')); }); });
    qa('[data-sub-back]', m).forEach(function (b) { b.addEventListener('click', closeSub); });
    m.addEventListener('click', function (e) { if (e.target === m) closeMenu(); });
    var panel = q('.cphl-mm__panel', m), sx = null, sy = null;
    panel.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
    panel.addEventListener('touchend', function (e) {
      if (sx === null) return;
      var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
      sx = null;
      if (Math.abs(dx) > 70 && Math.abs(dx) > Math.abs(dy) * 1.5) {
        if (dx < 0 && !st.sub) closeMenu();
        else if (dx > 0 && st.sub) closeSub();
      }
    }, { passive: true });
    desk.addEventListener && desk.addEventListener('change', function (e) { if (e.matches && st.menu) closeMenu(true); });
  }

  /* Søgning med live-resultater via Section Rendering API */
  var sCtrl = null, sCache = {}, sActive = -1;
  function openSearch() {
    var ov = q('[data-sov]', root);
    if (!ov) return;
    var fromMenu = st.menu;
    if (st.menu) closeMenu(true);
    if (st.mega) closeMega();
    if (st.acc) closeAcc(true);
    st.search = true;
    lastFocus = fromMenu ? q('[data-open-menu]', root) : document.activeElement;
    ov.classList.add('is-open');
    setExpanded('[data-open-search]', true);
    lock(true);
    syncState();
    var input = q('[data-sov-input]', ov);
    setTimeout(function () { input.focus({ preventScroll: true }); if (input.value) input.select(); }, 60);
  }
  function closeSearch(silent) {
    var ov = q('[data-sov]', root);
    if (!ov || !st.search) return;
    st.search = false;
    ov.classList.remove('is-open');
    setExpanded('[data-open-search]', false);
    if (!st.menu) lock(false);
    syncState();
    if (!silent && lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  function initSearch() {
    var ov = q('[data-sov]', root);
    if (!ov) return;
    var input = q('[data-sov-input]', ov);
    var live = q('[data-sov-live]', ov);
    var start = q('[data-sov-start]', ov);
    var clear = q('[data-sov-clear]', ov);
    var url = ov.getAttribute('data-url') || (((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'search/suggest');
    var sectionId = ov.getAttribute('data-section') || 'cphl-predictive-search';

    qa('[data-open-search]', root).forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); openSearch(); }); });
    var x = q('[data-close]', ov);
    if (x) x.addEventListener('click', function () { closeSearch(); });
    ov.addEventListener('click', function (e) { if (e.target === ov) closeSearch(); });

    function items() { return qa('[data-ps-item]', live); }
    function mark(n) {
      var list = items();
      list.forEach(function (el) { el.classList.remove('is-active'); });
      sActive = n;
      if (n > -1 && list[n]) {
        list[n].classList.add('is-active');
        var a = list[n].matches('a') ? list[n] : q('a', list[n]);
        input.setAttribute('aria-activedescendant', '');
        if (a && a.scrollIntoView) a.scrollIntoView({ block: 'nearest' });
      }
    }
    function show(html) {
      live.innerHTML = html;
      live.hidden = false;
      start.hidden = true;
      input.setAttribute('aria-expanded', 'true');
      sActive = -1;
    }
    function reset() {
      live.hidden = true;
      live.innerHTML = '';
      start.hidden = false;
      input.setAttribute('aria-expanded', 'false');
      sActive = -1;
    }
    var run = debounce(function () {
      var term = input.value.trim();
      if (term.length < 2) { reset(); return; }
      if (sCache[term]) { show(sCache[term]); return; }
      if (sCtrl) sCtrl.abort();
      sCtrl = 'AbortController' in window ? new AbortController() : null;
      ov.classList.add('is-loading');
      var u = url + '?q=' + encodeURIComponent(term) + '&section_id=' + sectionId +
        '&resources[type]=product,collection,page,query&resources[limit]=8&resources[limit_scope]=each&resources[options][unavailable_products]=last';
      fetch(u, sCtrl ? { signal: sCtrl.signal } : {})
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var res = q('[data-ps]', doc);
          if (!res) return;
          sCache[term] = res.outerHTML;
          if (input.value.trim() === term) show(res.outerHTML);
        })
        .catch(function () {})
        .then(function () { ov.classList.remove('is-loading'); });
    }, 170);
    input.addEventListener('input', function () { clear.hidden = !input.value; run(); });
    clear.addEventListener('click', function () { input.value = ''; clear.hidden = true; reset(); input.focus(); });
    input.addEventListener('keydown', function (e) {
      var list = items();
      if (e.key === 'ArrowDown' && list.length) { e.preventDefault(); mark(Math.min(sActive + 1, list.length - 1)); }
      else if (e.key === 'ArrowUp' && list.length) { e.preventDefault(); mark(Math.max(sActive - 1, -1)); }
      else if (e.key === 'Enter' && sActive > -1 && list[sActive]) {
        var a = list[sActive].matches('a') ? list[sActive] : q('a', list[sActive]);
        if (a) { e.preventDefault(); window.location.href = a.href; }
      }
    });
    ov.addEventListener('click', function (e) {
      var t = e.target.closest('[data-sov-term]');
      if (!t) return;
      e.preventDefault();
      input.value = t.getAttribute('data-sov-term');
      clear.hidden = false;
      input.focus();
      run();
    });
  }

  /* Kurven: skuffen styres af assets/cphl-cart.js. Her kun et lille hop i boblen og en opdateret skærmlæsertekst. */
  function initCart() {
    var bubble = q('.cphl-hd__bubble', root);
    var link = q('[data-cart-link]', root);
    function bump() {
      if (!bubble) return;
      bubble.classList.remove('is-bump');
      void bubble.offsetWidth;
      bubble.classList.add('is-bump');
    }
    document.addEventListener('ajaxProduct:added', bump);
    if (bubble && link && 'MutationObserver' in window) {
      new MutationObserver(function () {
        var n = parseInt(bubble.textContent, 10) || 0;
        var tpl = n === 1 ? ((window.cphlT && cphlT.chrome_cart_one) || 'Kurv, {n} vare') : ((window.cphlT && cphlT.chrome_cart_other) || 'Kurv, {n} varer');
        link.setAttribute('aria-label', tpl.replace('{n}', n));
      }).observe(bubble, { childList: true, subtree: true, characterData: true });
    }
    document.addEventListener('cphl:cart-updated', function () { initStore(); });
  }

  function closeAll() {
    if (st.search) closeSearch();
    if (st.menu) closeMenu();
    if (st.mega) closeMega();
    if (st.acc) closeAcc();
  }

  function onKey(e) {
    if (e.key === 'Escape') {
      if (st.sub) { closeSub(); return; }
      if (anyOpen()) { e.preventDefault(); closeAll(); }
      return;
    }
    if (e.key === 'Tab') {
      if (st.search) trap(q('[data-sov]', root), e);
      else if (st.menu) trap(q(st.sub ? '[data-sub="' + st.sub + '"]' : '.cphl-mm__panel', root), e);
    }
  }

  function init() {
    root = q('[data-cphl-header]');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';
    hd = q('[data-hd]', root);
    scrim = q('[data-scrim]', root);
    st = { mega: null, acc: false, menu: false, search: false, sub: null };
    initUsps();
    initStore();
    setInterval(initStore, 60000);
    initSticky();
    initFit();
    initMega();
    initAccount();
    initMenu();
    initSearch();
    if (scrim) scrim.addEventListener('click', closeAll);
  }

  document.addEventListener('keydown', function (e) { if (root) onKey(e); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); initCart(); applyEta(); });
  else { init(); initCart(); applyEta(); }
  document.addEventListener('cphl:cart-updated', function () { applyEta(); });

  /* Temaeditoren */
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector('[data-cphl-header]')) { lock(false); init(); }
    if (e.target) applyEta(e.target);
  });
  document.addEventListener('shopify:block:select', function (e) {
    if (!root || !e.target || !e.target.hasAttribute('data-mega')) return;
    if (desk.matches) openMega(e.target.getAttribute('data-mega'));
  });
  document.addEventListener('shopify:block:deselect', function () { if (st.mega) closeMega(); });
})();

/* Frostet bund: glassets kant følger tekstblokkens top, så teksten altid står på det frostede felt. Plutonic, 2026-10-08. */
(function () {
  function fit(c) {
    var p = c.querySelector('[data-glass-panel]');
    var h = c.offsetHeight;
    if (!p || !h) return;
    var top = 0, n = p;
    while (n && n !== c) { top += n.offsetTop; n = n.offsetParent; }
    if (n !== c) top = p.getBoundingClientRect().top - c.getBoundingClientRect().top;
    var pct = Math.max(6, Math.min(94, top / h * 100));
    c.style.setProperty('--gt', pct.toFixed(1) + '%');
    c.classList.toggle('is-glass-tall', pct < 55);
  }
  var ro = 'ResizeObserver' in window ? new ResizeObserver(function (es) {
    for (var i = 0; i < es.length; i++) { var c = es[i].target.closest('[data-glass]'); if (c) fit(c); }
  }) : null;
  function scan(root) {
    var els = (root || document).querySelectorAll('[data-glass]');
    for (var i = 0; i < els.length; i++) {
      var c = els[i];
      fit(c);
      if (c.__cphlGlass) continue;
      c.__cphlGlass = 1;
      if (ro) { ro.observe(c); var p = c.querySelector('[data-glass-panel]'); if (p) ro.observe(p); }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); }); else scan();
  window.addEventListener('load', function () { scan(); });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { scan(); });
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  window.cphlGlassScan = scan;
})();
